import { useBadgingTranslation } from '../../../../ui/hooks';
import { useSystemRoles } from '../../../../ui/hooks/useSystemRoles';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Typography } from '@mui/material';
import React from 'react';
import { AccountBadgeActionsCell } from '../components/AccountBadgeTable/AccountBadgeActionsCell';
import { AccountBadgeDistributionCell } from '../components/AccountBadgeTable/AccountBadgeDistributionCell';
import { AccountBadgeNameCell } from '../components/AccountBadgeTable/AccountBadgeNameCell';
import { AccountBadgeStatusCell } from '../components/AccountBadgeTable/AccountBadgeStatusCell';
import { AccountBadgeContext } from '../contexts/AccountBadgeContext';
export function useAccountBadgeListColumns({ refetchAccountBadgeList, }) {
    const { systemRoleLabels } = useSystemRoles();
    const { t } = useBadgingTranslation();
    const { extendAccountBadgeTableColumns } = React.useContext(AccountBadgeContext);
    const defaultColumns = [
        {
            headerLabel: t('badges.badgeDetails.accountBadgeTable.headerLabels.badgeName'),
            sortKey: 'accountDisplayName',
            cellFunction: (row) => {
                const systemRoleLabel = row.columns.accountSystemRole ? systemRoleLabels[row.columns.accountSystemRole] : undefined;
                return (React.createElement(AccountBadgeNameCell, { accountBadge: row, descriptionContent: React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, systemRoleLabel) }));
            },
        },
        {
            headerLabel: t('badges.badgeDetails.accountBadgeTable.headerLabels.status'),
            sortKey: 'status',
            cellFunction: (row) => (React.createElement(AccountBadgeStatusCell, { status: row.columns.status, statusLastUpdatedAt: row.columns.statusLastUpdatedAt, statusReasonTitle: row.columns.statusReasonTitle, expiresAt: row.columns.expiresAt })),
        },
        {
            headerLabel: t('badges.badgeDetails.accountBadgeTable.headerLabels.distribution'),
            sortKey: 'distributionStatus',
            cellFunction: (row) => React.createElement(AccountBadgeDistributionCell, { accountBadge: row, onActionSuccess: refetchAccountBadgeList }),
        },
        {
            cellFunction: (row) => React.createElement(AccountBadgeActionsCell, { accountBadge: row, onActionSuccess: refetchAccountBadgeList }),
        },
    ];
    return extendAccountBadgeTableColumns ? extendAccountBadgeTableColumns(defaultColumns) : defaultColumns;
}
